// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ADID","textWrapper":"styles_textWrapper__2bPDt","arrowsWrapper":"styles_arrowsWrapper__17xra"};